import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { replace } from 'react-router-redux';

import { Filterbar } from './filter/Filter';
import { fetchFilter, updateBenefitList } from '../ducks/filter';
import { getFilter } from '../selectors';
import {
  filterFromLocation,
  createCenturionButtonProps as createCenturionButtonProperties,
  composeCategories,
} from '../utils';

export class FilterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberofbuttons: 0,
      filterCategory: null,
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    // Add condition to not call ducks
    if (!this.props.isCardUsingOneData && global.BROWSER) {
      this.props.fetchFilter(this.props.cardName, this.props.login, window?.location?.origin)
        .then(this.setInitialFilterCategory);
    } else {
      if (this.props.filters) {
        this.props.filters.categories = composeCategories(this.props.filters);
      }
      this.setInitialFilterCategory();
    }

    if (global.BROWSER) {
      window?.addEventListener('resize', this.handleResize);
    }
    this.handleResize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.cardname !== this.props?.cardname) {
      this.setState({ filterCategory: null });
    }
  }

  componentWillUnmount() {
    if (global.BROWSER) {
      window?.removeEventListener('resize', this.handleResize);
    }
  }

  setInitialFilterCategory = () => {
    // Check for filter param in URL to set initial filter category
    const filterCategory = filterFromLocation(this.props.location);
    if (filterCategory) {
      this.setState({
        filterCategory,
      });
      // remove the filter param from URL
      this.props.replace({
        ...this.props.location,
        query: '',
      });
    }
  }

   handleResize = () => {
     // determine size of filterbar by DLS size of screen width
     if (global.BROWSER) {
       const w = window?.innerWidth;
       // x-large
       if (w > 1280) {
         this.setState({
           numberofbuttons: 5,
         });
         // large
       } else if (w > 1023 && w <= 1280) {
         this.setState({
           numberofbuttons: 5,
         });
         // medium
       } else if (w > 767 && w <= 1023) {
         this.setState({
           numberofbuttons: 5,
         });
         // small
       } else if (w > 515 && w <= 767) {
         this.setState({
           numberofbuttons: 5,
         });
       } else if (w > 445 && w <= 515) {
         this.setState({
           numberofbuttons: 5,
         });
       } else if (w > 375 && w <= 445) {
         this.setState({
           numberofbuttons: 4,
         });
         // x-small
       } else {
         this.setState({
           numberofbuttons: 4,
         });
       }
     }
   }

  // eslint-disable-next-line react/no-unused-class-component-methods -- needed
  jumpToDisclaimer = () => {
    // eslint-disable-next-line unicorn/prefer-query-selector -- needed
    document.getElementById('benefits-disclaimer').scrollIntoView();
  }

  render() {
    if (!this.props.isCardUsingOneData) {
      if (!this.props.filter.data || !this.props.filter.data.categories
        || this.props.filter.error || !this.props.benefits
        || !this.props.benefits.data || this.props.benefits.data.length <= 6) {
        return null;
      }
    }

    // props to pass to filterbar to render centurionButton if applicable
    const centurionButtonProperties = createCenturionButtonProperties(this.props.login, this.props.cardname, this.props.env, this.props.accountKey);
    return (
      <div
        style={{ width: '100%' }}
        className="margin-1-tb margin-0-r"
      >
        <Filterbar
          cardname={this.props.cardname}
          typeOfThing="benefit"
          typeOfThingPlural="Benefits"
          filter={this.props.filters}
          onCategorySelection={this.props.updateBenefitsFilter}
          numberofbuttons={this.state.numberofbuttons}
          allThingsList={this.props.benefits}
          selectedByProp={this.state.filterCategory}
          centurionButtonProps={centurionButtonProperties}
          isCardUsingOneData={this.props.isCardUsingOneData}
          searchFilter={this.props.searchFilter}
          searchFilterData={this.props.searchFilterData}
          searchExperience={this.props.searchExperience}
          handleSearch={this.props.handleSearch}
          analytics={this.props?.analytics}
        />
      </div>
    );
  }
}

FilterContainer.propTypes = {
  fetchFilter: PropTypes.func.isRequired,
  updateBenefitsFilter: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    isFetching: PropTypes.bool,
    error: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.shape({
      category: PropTypes.string,
      ids: PropTypes.arrayOf(PropTypes.string),
    })),
  }),
  handleSearch: PropTypes.func,
  benefits: PropTypes.arrayOf(PropTypes.string),
  cardName: PropTypes.string,
  location: PropTypes.shape({
    query: PropTypes.shape({}),
  }).isRequired,
  replace: PropTypes.func.isRequired,
  login: PropTypes.bool.isRequired,
  env: PropTypes.string.isRequired,
  accountKey: PropTypes.string.isRequired,
  centurionButtonProps: PropTypes.shape({
    href: PropTypes.string,
  }),
  filters: PropTypes.shape({
    category: PropTypes.string,
    ids: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  isCardUsingOneData: PropTypes.bool,
};

FilterContainer.defaultProps = {
  cardName: null,
  filter: null,
  benefits: null,
  centurionButtonProps: null,
  isCardUsingOneData: false,
};

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchFilter,
    updateBenefitList,
    replace,
  }, dispatch);
}

export function mapStateToProps(state) {
  return {
    filter: getFilter(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterContainer);
